// src/zoom-out.tsx
import { createSvgIcon } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var ZoomOutIcon = createSvgIcon(
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18.6509 10.1603C18.6509 12.4118 17.6902 14.4423 16.1691 15.8796L20.7823 20.5134C21.0725 20.8049 21.0725 21.2874 20.7823 21.5789C20.6322 21.7296 20.4421 21.8 20.252 21.8C20.0618 21.8 19.8717 21.7296 19.7216 21.5789L15.0083 16.8446C15.0033 16.8395 14.9983 16.832 14.9933 16.8245C14.9883 16.8169 14.9833 16.8094 14.9783 16.8044C13.7775 17.5683 12.3565 18.0206 10.8254 18.0206C6.51244 18.0206 3 14.4925 3 10.1603C3 5.82808 6.51244 2.29999 10.8254 2.29999C15.1384 2.29999 18.6509 5.82808 18.6509 10.1603ZM10.8254 3.80772C7.33301 3.80772 4.50104 6.65231 4.50104 10.1603C4.50104 13.6683 7.33301 16.5129 10.8254 16.5129C14.3179 16.5129 17.1498 13.6683 17.1498 10.1603C17.1498 6.65231 14.3179 3.80772 10.8254 3.80772ZM7.8233 9.40643H13.8275C14.2377 9.40643 14.578 9.74818 14.578 10.1603C14.578 10.5724 14.2377 10.9142 13.8275 10.9142H7.8233C7.41301 10.9142 7.07277 10.5724 7.07277 10.1603C7.07277 9.74818 7.41301 9.40643 7.8233 9.40643Z",
      clipRule: "evenodd"
    }
  ),
  "ZoomOutIcon"
);

export {
  ZoomOutIcon
};
